/**
 * Created by swandelow on 11/08/17.
 */
angular.module("CarsSaraBo").directive("alertEmailsComponent", function () {
    return {
        restrict: 'E',
        controller: ["$routeParams", "$q", "$location", "$translate", "AlertEmailService", "PointOfSaleService", "$filter", "LoadingWheelService", "SessionService", "ModalService", AlertEmailsController],
        controllerAs: "ctrl",
        templateUrl: 'templates/alert-emails/alert-emails.component.html',
        scope: {} // isolated scope
    };
});

function AlertEmailsController($routeParams, $q, $location, $translate, alertEmailService, pointOfSaleService, $filter, loadingWheelService, sessionService, modalService) {
    var vm = this;

    function initialize() {
        loadingWheelService.show();
        vm.validations = {};
        vm.alertEmails = [];
        $q.all([
            alertEmailService.query({companyOid: $routeParams.companyOid}).$promise,
            pointOfSaleService.resource.query({companyOid: $routeParams.companyOid}).$promise
        ]).then(function (response) {
            vm.validations.alertEmails = true;
            vm.alertEmails = response[0];
            vm.pointsOfSale = response[1];
            loadingWheelService.hide();
            if (vm.alertEmails.length == 0) {
                vm.create();
            }
        });
        vm.editableAlert = sessionService.loggedUserAllowed('PERM_ALERT_CREATE') || sessionService.loggedUserAllowed('PERM_ALERT_DELETE');
        vm.order = {field: "", desc: false};
    }

    vm.pointOfSaleNames = function (pointOfSaleIds) {
        var pointOfSaleNames = _.map(pointOfSaleIds, function (id) {
            var pos = _.find(vm.pointsOfSale, {'oid': id});
            return pos != undefined ? pos.name : null;
        });

        return _.filter(pointOfSaleNames, null).join('/');
    };

    vm.typeNames = function (types) {
        return _.map(types, function (code) {
            return $translate.instant('alertEmail.' + code);
        }).join(", ");
    };

    vm.itemsToRemove = function () {
        return _.filter(vm.alertEmails, {"selected": true});
    };

    vm.remove = function () {
        var toRemove = vm.itemsToRemove();

        if (toRemove.length == 0) return;

        modalService.show("REMOVE_ALERT_TITLE", "REMOVE_ALERT_DESCRIPTION", function () {
            toRemove.forEach(function (e) {
                alertEmailService.remove({oid: e.oid, companyOid: $routeParams.companyOid});
                vm.alertEmails.splice(vm.alertEmails.indexOf(e), 1);

                if (vm.alertEmails.length == 0) {
                    vm.create();
                }
            });
        });
    };

    vm.edit = function (alertEmail) {
        $location.path("/company/" + $routeParams.companyOid + "/alertEmail/" + alertEmail.oid)
    };

    vm.create = function () {
        $location.path("/company/" + $routeParams.companyOid + "/alertEmail/new")
    };

    vm.sort = function (fieldName, desc) {
        if (vm.order.field != fieldName) {
            vm.order.field = fieldName;
            vm.order.desc = desc != undefined ? desc : false;
        } else {
            vm.order.desc = desc != undefined ? desc : !vm.order.desc;
        }

        if (fieldName == 'language') {
            filterByTransformedValue(vm.order.desc, sortByTransformedLanguage);
            return;
        }
        if (fieldName == 'types') {
            filterByTransformedValue(vm.order.desc, sortByTransformedTypes);
            return;
        }
        if (fieldName == 'pos') {
            filterByTransformedValue(vm.order.desc, sortByTransformedPointOfSales);
            return;
        }

        vm.alertEmails = $filter('orderBy')(vm.alertEmails, vm.order.field, vm.order.desc);
    };

    function sortByTransformedLanguage(a) {
        return $translate.instant('common.' + a.language);
    }

    function sortByTransformedTypes(a) {
        return vm.typeNames(a.types);
    }

    function sortByTransformedPointOfSales(a) {
        return vm.pointOfSaleNames(a.pointOfSaleOids);
    }

    function filterByTransformedValue(desc, customizedFunction) {
        var order = desc ? -1 : 1;
        vm.alertEmails.sort(function compare(a, b) {
            if (customizedFunction(a) < customizedFunction(b))
                return order;
            if (customizedFunction(a) > customizedFunction(b))
                return order * -1;
            return 0;
        });
    }

    initialize();
}


//////////////////
// WEBPACK FOOTER
// ./public/app/alert-emails/alert-emails.component.js
// module id = 935
// module chunks = 3